import { render, staticRenderFns } from "./ProductCategoriesRecursive.vue?vue&type=template&id=1b06ed6e&scoped=true&"
import script from "./ProductCategoriesRecursive.vue?vue&type=script&lang=js&"
export * from "./ProductCategoriesRecursive.vue?vue&type=script&lang=js&"
import style0 from "./ProductCategoriesRecursive.vue?vue&type=style&index=0&id=1b06ed6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b06ed6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b06ed6e')) {
      api.createRecord('1b06ed6e', component.options)
    } else {
      api.reload('1b06ed6e', component.options)
    }
    module.hot.accept("./ProductCategoriesRecursive.vue?vue&type=template&id=1b06ed6e&scoped=true&", function () {
      api.rerender('1b06ed6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Modal/AdminPage/ProductsPage/ProductCategoriesRecursive.vue"
export default component.exports